import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Material-UI icons for visibility toggle
import { Visibility, VisibilityOff } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';

const ChangePassword = () => {
  const { id } = useParams(); // Get the user id from the route parameters
  const [formData, setFormData] = useState({
    email: '',
    newPassword: '',
    confirmPassword: '', // Add confirmPassword field
  });
  const [errors, setErrors] = useState({});
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user data and set the email
    const accessToken = localStorage.getItem("access_token");
    axios.get(
            `${process.env.REACT_APP_API_URL}/auth/get-user/${id}`,
            {
              headers: {
                Authorization: `${accessToken}`,
              },
            }
          )
      .then(response => {
        if (response.data) {
          setFormData(prevState => ({
            ...prevState,
            email: response.data.email, // Set the fetched email
          }));
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          console.error('401 Error-------');
          localStorage.clear();
          navigate('/auth/login');
        }
        console.error('There was an error fetching the user data!', error);
      });
  }, [id, navigate]);

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!formData.newPassword) {
      formErrors.passwordError = "The new password cannot be null";
      isValid = false;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      formErrors.confirmPasswordError = "New Password and Confirm Password do not match";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const accessToken = localStorage.getItem("access_token");
      axios.put(
            `${process.env.REACT_APP_API_URL}/auth/admin-update-user-password`,
            formData,
            {
              headers: {
                Authorization: `${accessToken}`,
              },
            }
          )
        .then(response => {
          if (response.status === 200) {
            toast.success('Password successfully updated!'); // Success notification
            setTimeout(() => {
              navigate('/user-list'); // Navigate to /user-list after success
            }, 1000); // Redirect after 1 second
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            console.error('401 Error-------');
            localStorage.clear();
            navigate('/auth/login');
          }
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message || 'An error occurred. Please try again.'); // Error notification
          } else {
            console.error('There was an error updating the password!', error);
          }
        });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Change User Password
                </MDTypography>
              </MDBox>

              <MDBox p={3}>
                <form onSubmit={handleSubmit}>
                  <MDBox display="flex" flexDirection="column" mb={3}>
                    <MDBox mb={2} width="100%">
                      <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                        Email <span style={{ color: 'red' }}>*</span>
                      </MDTypography>
                      <MDInput
                        type="email"
                        fullWidth
                        name="email"
                        value={formData.email}
                        InputProps={{
                          readOnly: true, // Make the field read-only
                        }}
                      />
                    </MDBox>
                    <MDBox mb={2} width="100%">
                      <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                        New Password <span style={{ color: 'red' }}>*</span>
                      </MDTypography>
                      <MDInput
                        type={showNewPassword ? "text" : "password"}
                        fullWidth
                        name="newPassword"
                        value={formData.newPassword}
                        onChange={handleChange}
                        error={Boolean(errors.passwordError)}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.passwordError ? 'red' : undefined,
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <MDButton
                                onClick={() => setShowNewPassword(prev => !prev)}
                                sx={{ padding: 0 }}
                              >
                                {showNewPassword ? <VisibilityOff /> : <Visibility />}
                              </MDButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {errors.passwordError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          {errors.passwordError}
                        </MDTypography>
                      )}
                    </MDBox>
                    {/* Confirm Password Field */}
                    <MDBox mb={2} width="100%">
                      <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                        Confirm Password <span style={{ color: 'red' }}>*</span>
                      </MDTypography>
                      <MDInput
                        type={showConfirmPassword ? "text" : "password"}
                        fullWidth
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        error={Boolean(errors.confirmPasswordError)}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.confirmPasswordError ? 'red' : undefined,
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <MDButton
                                onClick={() => setShowConfirmPassword(prev => !prev)}
                                sx={{ padding: 0 }}
                              >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </MDButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {errors.confirmPasswordError && (
                        <MDTypography variant="caption" color="error" fontWeight="light">
                          {errors.confirmPasswordError}
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>

                  <MDBox mt={4} display="flex" justifyContent="end">
                    <MDButton variant="gradient" color="info" type="submit">
                      Change Password
                    </MDButton>
                  </MDBox>
                </form>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Add ToastContainer to render toast notifications */}
      <ToastContainer />
    </DashboardLayout>
  );
};

export default ChangePassword;
